import { useMemo } from 'react';

import { staticRoutes } from 'Deer/constants/routes';
import { useRouteToNavLevels } from 'Deer/hooks/useRouteToL3';
import { IntentFilters } from 'Deer/intent/components/Layout/IntentFilters.layout';
import { IntentBreadcrumbType, IntentValuesType } from 'Deer/intent/types/IntentCommonTypes';
import { useHistory, useLocation } from 'react-router-dom';
import { checkSettingsPageRevampEnabled } from 'utils/helpers/featureFlags';

import { AgGridEllipsisMenu } from 'uiToolkitV1/AgGridWrapperV2/components/EllipsisMenu/AgGridEllipsisMenu';

import { useGetCSVDownloadOptions } from '../EmployeesRevamp/dataHooks';

type Props = {
  breadcrumbs: IntentBreadcrumbType;
  isEmployeeListPage?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  gridRef?: any;
};

export type EmployeeRosterIntentType = {
  label: string;
  onClick: () => void;
  visible: () => boolean;
  value: {
    myData?: IntentValuesType;
    team?: {
      directReports?: IntentValuesType;
      allReports?: IntentValuesType;
    };
    company?: IntentValuesType;
  };
  applicableGroupByValues?: {
    value: string;
    label: string;
  }[];
};

const EmployeeRosterIntentDropdown = ({ breadcrumbs, isEmployeeListPage, gridRef }: Props) => {
  const { l1Module } = useRouteToNavLevels();
  const history = useHistory();
  const { pathname } = useLocation();

  // eslint-disable-next-line arrow-body-style
  const intentDropdownOptions = useMemo<Array<EmployeeRosterIntentType>>(() => {
    return [
      {
        label: `Employee data`,
        onClick: () => {
          history.push({
            pathname: staticRoutes.company.settings.platform.employees,
          });
        },
        visible: () => true,
        value: {
          company: {
            path: staticRoutes.company.settings.platform.employees,
          },
        },
      },
      {
        label: `Access control`,
        onClick: () => {
          history.push({
            pathname: staticRoutes.company.settings.platform.access,
          });
        },
        visible: () => true,
        value: {
          company: {
            path: staticRoutes.company.settings.platform.access,
          },
        },
      },
      {
        label: `HRIS plugin`,
        onClick: () => {
          history.push({
            pathname: staticRoutes.company.settings.plugins.hris,
          });
        },
        visible: () => true,
        value: {
          company: {
            path: staticRoutes.company.settings.plugins.hris,
          },
        },
      },
    ];
  }, [history]);

  const selectedIntent = useMemo(
    () => intentDropdownOptions.find((option) => pathname.includes(option.value[l1Module]?.path)),
    [intentDropdownOptions, l1Module, pathname]
  );

  const ellipsisOptions = useGetCSVDownloadOptions({ gridRef });

  return (
    <IntentFilters
      // @ts-expect-error options type error
      intentDropdownOptions={intentDropdownOptions.filter((option) => option.visible())}
      selectedIntent={selectedIntent?.label ?? ''}
      moduleName="Employee roster"
      breadcrumbs={breadcrumbs}
      intentTitle="Employee Roster"
      KebabMenu={
        checkSettingsPageRevampEnabled() && isEmployeeListPage ? <AgGridEllipsisMenu options={ellipsisOptions} /> : null
      }
      showKebabMenu={checkSettingsPageRevampEnabled() && isEmployeeListPage}
    />
  );
};

export { EmployeeRosterIntentDropdown };
